// extracted by mini-css-extract-plugin
module.exports = {"root":"_19ZkXXp","section":"_2lAMi6q _1ZWPIqK","sidebar":"_55RDDyy"};